var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 11,
    viewBox: "0 0 32 11",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "45.974%",
    y1: "-2.006%",
    x2: "54.877%",
    y2: "100%",
    id: "j3p02b5uga"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#222357",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#254AA5",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v10.375H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.55 7.03c-.019-1.44 1.282-2.243 2.263-2.72 1.007-.49 1.345-.805 1.34-1.243-.007-.67-.802-.967-1.547-.978-1.3-.02-2.055.35-2.655.631L15.483.53c.602-.277 1.718-.52 2.875-.53 2.716 0 4.492 1.34 4.502 3.419.01 2.638-3.649 2.784-3.624 3.963.009.357.35.739 1.098.836.37.049 1.391.086 2.549-.447l.454 2.119a6.931 6.931 0 0 1-2.42.444c-2.555 0-4.353-1.36-4.367-3.304m11.155 3.121c-.496 0-.914-.29-1.1-.733L22.725.156h2.714l.54 1.492h3.316l.313-1.492H32l-2.087 9.995h-2.208zm.38-2.7.782-3.753h-2.144l1.361 3.753zm-14.826 2.7L11.12.156h2.586l2.138 9.995H13.26zm-3.825 0L6.743 3.348l-1.09 5.784c-.127.646-.631 1.019-1.192 1.019h-4.4L0 9.861c.903-.196 1.93-.512 2.551-.85.38-.207.49-.388.614-.879L5.227.156H7.96l4.19 9.995H9.433z",
    fill: "url(#j3p02b5uga)",
    fillRule: "nonzero",
    transform: "matrix(1 0 0 -1 0 10.334)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.0c5de96bfa96ce0ebff3cd9d413b22ce.svg";
export { ForwardRef as ReactComponent };